import type { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { ThemeProvider } from '@material-ui/core';
import globalHooks from 'src/lib/globalHooks';

import GlobalStyles from './components/shared/GlobalStyles';
import RTL from './components/shared/RTL';
import SplashScreen from './components/shared/SplashScreen';
import useAuth from './hooks/useAuth';
import useScrollReset from './hooks/useScrollReset';
import useSettings from './hooks/useSettings';
import routes from './routes';
import { createTheme } from './theme';
import { ConfigProvider } from './contexts/ConfigContext';
import { IconProvider } from './contexts/IconContext';
import { LocalStorageProvider } from './contexts/LocalStorageContext';

globalHooks.setHook('auth', useAuth).setHook('snackBar', useSnackbar);

const App: FC = () => {
  const content = useRoutes(routes);
  const { settings } = useSettings();
  const auth = useAuth();
  useScrollReset();

  const theme = createTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    roundedCorners: settings.roundedCorners,
    theme: settings.theme
  });
  
  return (
    <ThemeProvider theme={theme}>
      <ConfigProvider>
        <LocalStorageProvider>
          <IconProvider>
            <RTL direction={settings.direction}>
              <SnackbarProvider
                dense
                maxSnack={3}
              >
                <GlobalStyles />
                <globalHooks.ReactHooksWrapper />
                {auth.isInitialized ? content : <SplashScreen />}
              </SnackbarProvider>
            </RTL>
          </IconProvider>
        </LocalStorageProvider>
      </ConfigProvider>
    </ThemeProvider>
  );
};

export default App;
